import axios from 'axios'
import Auth from './common/Auth'

export default class Config {

    DConnect() {
        let auth = new Auth()
        return axios.create({
            method: 'get',
            baseURL: this.BaseURL(),
            timeout: 60000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + auth.getToken()
            }
        })
    }

    DConnectBOG() {
        let auth = new Auth()
        return axios.create({
            method: 'get',
            baseURL: this.BOGBaseURL(),
            timeout: 60000,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + auth.getBOGToken()
            }
        })
    }


    DConnectBOGPost() {
        let auth = new Auth()
        return axios.create({
            method: 'get',
            baseURL: this.BOGBaseURL(),
            timeout: 60000,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + auth.getBOGToken()
            }
        })
    }

    DConnect1() {
        return axios.create({
            method: 'get',
            baseURL: this.BaseURL(),
            timeout: 60000,
            headers: {
                'Content-Type': 'application/json'
            }
        })
    }

    DFile() {
        let auth = new Auth()
        return axios.create({
            baseURL: this.BaseURL(),
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + auth.getToken()
            }
        })
    }

    PostOptions(itms, area) {
        let auth = new Auth()
        return {
            method: 'post',
            url: this.BaseURL() + 'mresources/' + area,
            data: itms,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Authorization': JSON.stringify(auth.token())
            }
        }
    }

    PostMulti(itms, area) {
        let auth = new Auth()
        return {
            method: 'post',
            url: this.BaseURL() + 'mresources/' + area,
            data: itms,
            headers: {
                'Authorization': JSON.stringify(auth.token())
            }
        }
    }

    ImagePath(folder) {
        let auth = new Auth()
        return (this.BaseURL() + folder + '/' + Number(auth.getCompany()) + '/')
    }

    BOGBaseURL() {
        //return 'http://logiciel-test-srv.com:8091/api/v1/'
        return 'https://orassvas.bog.gov.gh/v1/';
    }

    BaseURL() {
        //return 'http://logiciel-test-srv.com:8091/api/v1/' 
        //return 'http://localhost:9080/api/v1/';
        // return 'https://rbknd.zigloi.com/api/v1/';
       // return 'http://logicielexchange.com:8091/api/v1/';
       return 'https://obkd.zigloi.com:8443/api/v1/';
    }
}   